// store/models.js
import { Models } from '@/database'

const state = () => ({
  models: [],
  loading: false,
  loaded: false,
  error: null
})

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  
  SET_MODELS(state, models) {
    state.models = models
  },
  
  SET_ERROR(state, error) {
    state.error = error
  },
  
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  async fetchModels({ commit }, params = {}) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      // Initialize the models API if not already done
      if (!this.modelsApi) {
        this.modelsApi = new Models()
      }
      if (!this.loaded) {
        const models = await this.modelsApi.getModels(params)
        commit('SET_MODELS', models)
        this.loaded = true
      }
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch models')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async refreshModels({ dispatch }) {
    return dispatch('fetchModels', {})
  }
}

const getters = {
  allModels: (state) => state.models,
  isLoading: (state) => state.loading,
  error: (state) => state.error,
  getModelById: (state) => (id) => {
    return state.models.find(model => model.id === id)
  },
  getModelsByType: (state) => (type) => {
    return state.models.filter(model => model.type === type)
  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
